module.exports = __webpack_public_path__ + "static/media/card-profile1-square.3122abf4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faces/card-profile1-square.jpg
// module id = 467
// module chunks = 0